import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserAccountModel } from 'starbase-launcher';
import { StarbaseNotificationService } from 'starbase-notification';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  // Dash Module subscriptions vars
  // public subscriptionsList$: Observable<{ module: string, subName: string, subscribed: boolean }[]>;
  correspSummaryDaily: { uid: any; userAccountUID: any; userAccount: UserAccountModel };
  correspAssignedDaily: { uid: any; userACcountUID: any; userAccount: UserAccountModel };

  constructor(private notiSvc: StarbaseNotificationService) {
  }

  public loadSubscriptions(userUID: number): Observable<{ module: string; subName: string; subscribed: boolean }[]> {
    // placeholder
    return of([]);
  }

  public toggleSubscription(module: string, subName: string, userAccountUID: number | string): void {
    // placeholder
  }

  private sendToggleToServer(uri: string, accountId: string, subName: string = ''): void {
    // placeholder
  }
}
